import DateTime, { type ITimeZone } from '@dealroadshow/uikit-date-time';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { DEFAULT_TIME_ZONE } from '@framework/timezone/constants';

interface IDateCellProps {
  value: string | null | undefined,
  displayFormat?: string,
  tooltipFormat?: string,
  tooltipContent?: string,
  timeZone?: ITimeZone,
}

const DateCell = ({
  value,
  displayFormat = MONTH_DAY_YEAR_FORMAT,
  tooltipFormat,
  tooltipContent,
  timeZone = DEFAULT_TIME_ZONE,
}: IDateCellProps) => {
  if (!value) {
    return (<>-</>);
  }

  const date = new DateTime(value, { timeZone });
  const display = date.format(displayFormat);
  const tooltip = tooltipContent || (tooltipFormat ? date.format(tooltipFormat) : null);

  if (tooltip) {
    return (
      <Tooltip content={ tooltip }>
        { display }
      </Tooltip>
    );
  }

  return (<>{ display }</>);
};

export default DateCell;
